import { StudioType } from "../../enums";
import { IStudioSelectItemModel } from "../models/studioSelectItemModel";

/**
 * A studio whose ONLY type is Store — a pure shop with no group classes,
 * individual services, or gym. Used to tailor navigation, onboarding and the
 * dashboard for shop-only studios.
 */
export const isStoreOnlyStudio = (studio?: IStudioSelectItemModel): boolean =>
  studio?.types?.length === 1 && studio.types[0] === StudioType.Store;

/**
 * The studio setting "Обектът не използва планове": hides the plans administration
 * ("Планове", "Типове планове", "Зареждане на карта"), the plans on a client's and a
 * family's profile and the client's "Моите планове". A studio that is not loaded yet
 * counts as using plans, which is what every studio did before the setting existed.
 */
export const studioHidesPlans = (studio?: IStudioSelectItemModel): boolean =>
  studio?.studioDoesNotUsePlans === true;

/**
 * The studio setting "Обектът не използва тренировки": hides the client's
 * "Моите тренировки" and the "Тренировки" row and page on a client's profile. Off, the
 * row shows for every client, with or without workouts. Staff still reach a booking's
 * workout from the planner.
 */
export const studioHidesWorkouts = (studio?: IStudioSelectItemModel): boolean =>
  studio?.studioDoesNotUseWorkouts === true;

/**
 * The studio setting "Обектът не използва метрики": hides the client's "Моите метрики"
 * and the "Метрики" row on a client's profile. A studio saved before the setting existed
 * keeps them.
 */
export const studioHidesBodyMetrics = (studio?: IStudioSelectItemModel): boolean =>
  studio?.studioDoesNotUseBodyMetrics === true;

/**
 * The studio setting "Обектът не използва цели": hides the client's "Моите цели" and the
 * "Цели" row/page on a client's profile. A studio saved before the setting existed keeps
 * them.
 */
export const studioHidesGoals = (studio?: IStudioSelectItemModel): boolean =>
  studio?.studioDoesNotUseGoals === true;

/**
 * The studio setting "Обектът не използва портфолиа": hides the employees' portfolio field
 * on a service. The portal's "Виж портфолио" is dropped on the backend. A studio that is not
 * loaded yet counts as using portfolios, which is what every studio did before the setting
 * existed.
 */
export const studioHidesServicePortfolios = (
  studio?: IStudioSelectItemModel,
): boolean => studio?.studioDoesNotUseServicePortfolios === true;

/**
 * "Показвай комисионните на служителите в: Никъде (обектът не използва комисионни)":
 * hides the employees' "Комисионни проценти". The reports and the dashboard drop their
 * commission figures on the backend. A studio that is not loaded yet counts as using
 * commissions, which is what every studio did before the option existed.
 */
export const studioHidesCommissions = (
  studio?: IStudioSelectItemModel,
): boolean => studio?.studioDoesNotUseCommissions === true;
